import React from 'react'

interface ButtonProps {
    onClick?: () => void
    href?: string
    target?: string
    rel?: string
    download?: boolean | string
    classNames?: string
    title?: string
    variant?: 'primary' | 'secondary'
}

const Button: React.FC<ButtonProps> = ({
    onClick,
    href,
    target,
    rel,
    download,
    title,
    variant = 'primary',
    classNames,
}: ButtonProps) => {
    const getVariant = () => {
        switch (variant) {
            case 'primary':
                return 'bg-primary hover:bg-primaryDark text-secondary'
            case 'secondary':
                return 'bg-secondary hover:bg-secondaryDark text-background'
        }
    }

    const content = (
        <div
            className={
                `inline-flex items-center justify-center rounded-md border border-transparent px-3 py-2 md:px-5 md:py-3 text-sm md:text-base font-medium ${getVariant()} ` +
                (classNames ?? '')
            }
        >
            {title}
        </div>
    )

    if (href) {
        return (
            <a href={href} target={target} rel={rel} download={download} className='inline-flex rounded-md shadow cursor-pointer'>
                {content}
            </a>
        )
    }

    return (
        <div className='inline-flex rounded-md shadow cursor-pointer' onClick={onClick}>
            {content}
        </div>
    )
}

export default Button
